import { PcmpMarketingQueueTable } from '../components/PcmpMarketingQueue/PcmpMarketingQueueTable';

export function PcmpMarketingQueuePage() {
  return <PcmpMarketingQueueTable />;
}
